export default __webpack_public_path__ + "static/media/zrx.e61d1eb1.svg";